export const FRONTEND_URL = 'https://builder.kiratalent.com';

export const API_URL =
  process.env.REACT_APP_ENVIRONMENT === 'production' ||
  process.env.REACT_APP_ENVIRONMENT === 'test'
    ? 'https://app.kiratalent.com/'
    : 'http://localhost:8000';

export const NECTAR_URL = ['production', 'test'].includes(
  process.env.REACT_APP_ENVIRONMENT
)
  ? 'https://app.kiratalent.com/n/'
  : 'http://localhost/n/';

export const SUB_DOMAIN = ['production', 'test'].includes(
  process.env.REACT_APP_ENVIRONMENT
)
  ? '.kiratalent.com'
  : 'localhost';
